/* ride.parts product page.

   Two small jobs, no fetching:
   1. Thumbnails swap the main gallery image.
   2. Option chips pick a variant, then update the hidden id input, the price, the
      Add to cart button, the main image and the ?variant= query.

   The variant data is printed by sections/ride-product.liquid into a JSON script tag.
*/
(function () {
  'use strict';

  if (customElements.get('ride-product-form')) return;

  class RideProductForm extends HTMLElement {
    connectedCallback() {
      const dataEl = this.querySelector('[data-ride-variants]');
      if (!dataEl) return;

      try {
        this.variants = JSON.parse(dataEl.textContent);
      } catch (e) {
        this.variants = [];
      }
      if (!this.variants.length) return;

      this.idInput = this.querySelector('[data-ride-variant-id]');
      this.priceEl = this.querySelector('[data-ride-price]');
      this.compareEl = this.querySelector('[data-ride-compare]');
      this.addBtn = this.querySelector('[data-ride-add]');
      this.chips = Array.prototype.slice.call(this.querySelectorAll('[data-ride-value]'));

      const root = this.closest('.ride-product') || document;
      this.mainImg = root.querySelector('[data-ride-main]');
      this.thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-ride-thumb]'));

      this.selection = this.readSelection();

      this.chips.forEach((chip) => {
        chip.addEventListener('click', () => {
          const index = Number(chip.dataset.option);
          this.selection[index] = chip.dataset.value;
          this.update(false, index);
        });
      });

      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => this.showImage(thumb.dataset));
      });

      this.update(true);
    }

    readSelection() {
      const selection = [];
      this.chips.forEach((chip) => {
        const index = Number(chip.dataset.option);
        if (chip.classList.contains('is-selected')) selection[index] = chip.dataset.value;
        if (selection[index] === undefined) selection[index] = null;
      });
      // No chips means a single default variant.
      if (!this.chips.length && this.variants[0]) return this.variants[0].options.slice();
      return selection;
    }

    matches(variant, selection) {
      return selection.every((value, i) => value === null || variant.options[i] === value);
    }

    // A value is offered when some available variant carries it together with the
    // other currently selected values.
    isValueAvailable(index, value) {
      const probe = this.selection.slice();
      probe[index] = value;
      return this.variants.some((v) => v.available && this.matches(v, probe));
    }

    // changedIndex is the option the shopper just clicked. When the new combination
    // does not exist we keep that choice and let the other options move, which is what
    // every Shopify variant picker does.
    update(initial, changedIndex) {
      let variant = this.variants.find((v) => this.matches(v, this.selection));

      if (!variant && changedIndex !== undefined) {
        const kept = this.selection[changedIndex];
        variant =
          this.variants.find((v) => v.available && v.options[changedIndex] === kept) ||
          this.variants.find((v) => v.options[changedIndex] === kept);
      }

      if (!variant) variant = this.variants.find((v) => v.available) || this.variants[0];
      if (!variant) return;

      // Snap the selection to the variant we actually landed on.
      this.selection = variant.options.slice();

      this.chips.forEach((chip) => {
        const index = Number(chip.dataset.option);
        const selected = this.selection[index] === chip.dataset.value;
        chip.classList.toggle('is-selected', selected);
        chip.setAttribute('aria-pressed', selected ? 'true' : 'false');
        chip.classList.toggle('is-unavailable', !this.isValueAvailable(index, chip.dataset.value));
      });

      if (this.idInput) this.idInput.value = variant.id;
      if (this.priceEl) this.priceEl.textContent = variant.price;

      if (this.compareEl) {
        if (variant.compare_at_price) {
          this.compareEl.textContent = variant.compare_at_price;
          this.compareEl.hidden = false;
        } else {
          this.compareEl.textContent = '';
          this.compareEl.hidden = true;
        }
      }

      if (this.addBtn) {
        this.addBtn.disabled = !variant.available;
        this.addBtn.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }

      if (variant.image) this.showImage(variant.image);

      if (!initial && window.history && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    showImage(data) {
      if (!this.mainImg || !data || !data.src) return;
      this.mainImg.src = data.src;
      if (data.srcset) this.mainImg.srcset = data.srcset;
      if (data.alt) this.mainImg.alt = data.alt;
      this.mainImg.style.objectPosition = data.position || '50% 50%';
      const id = String(data.id || data.imageId || '');
      this.thumbs.forEach((thumb) => {
        const active = id !== '' && thumb.dataset.imageId === id;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }
  }

  customElements.define('ride-product-form', RideProductForm);
})();
